import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  const [lang, setLang] = useState(localStorage.getItem("nl_lang") || "NL");
  const changeLang = (l) => {
    setLang(l);
    localStorage.setItem("nl_lang", l);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing lang={lang} setLang={changeLang} />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Landing lang={lang} setLang={changeLang} />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
